import { makeStyles } from "@material-ui/core";

export default makeStyles(
  {
    divider: {
      marginLeft: 5,
      marginRight: 5,
      marginTop: 5
    },
    menuItem: {
      display: "flex",
      gap: "10px"
    },
    menuLabel: {
      alignSelf: "center",
      color: "#3884ff",
      fontSize: "0.875rem"
    },
    menuWrapper: {
      marginTop: 5
    }
  },
  {
    name: "MenuLoginExistingAccount"
  }
);
